export default "__VITE_ASSET__hItCb1Q9__"